import { Paper } from "@mui/material";
import { useEffect, useState } from "react";
import { useRfpCoverages } from "@platform/api";

import { CircularProgressCentered } from "../../../../components/CircularProgressCentered";

import { getReviewData } from "./getReviewData";
import { Review } from "./Review";
import { FinalDecisionFormValues, ReviewSection } from "./types";
import { useGetCarriers } from "./useGetCarriers";
import { useGetProducts } from "./useGetProducts";
import { reviewDataToReviewSections } from "./utils";

interface Props {
  rfpId: string;
  data: FinalDecisionFormValues;
}

const FinalDecisionsReviews = ({ rfpId, data }: Props): React.JSX.Element => {
  const [review, setReview] = useState<ReviewSection[]>([]);
  const { data: rfpCoverages, isLoading: isLoadingRfpCoverages } =
    useRfpCoverages({ rfpId });
  const { carrierMap, isLoading: isLoadingCarriers } = useGetCarriers(rfpId);
  const { productMap, isLoading: isLoadingProducts } = useGetProducts(rfpId);

  useEffect(() => {
    if (!rfpCoverages) {
      return;
    }

    const reviewData = getReviewData({
      formValues: data,
      carrierMap,
      productMap,
      rfpCoverages,
    });
    setReview(reviewDataToReviewSections(reviewData, true));
  }, [data, productMap, carrierMap, rfpCoverages]);

  return (
    <Paper variant="outlined" sx={{ mt: 2, p: 2 }}>
      {isLoadingRfpCoverages || isLoadingCarriers || isLoadingProducts ? (
        <CircularProgressCentered />
      ) : review.length > 0 ? (
        review.map((section) => <Review key={section.title} {...section} />)
      ) : null}
    </Paper>
  );
};

export { FinalDecisionsReviews };
